export default __webpack_public_path__ + "static/media/spiral.38b624be.png";